import React    from 'react';
import logo     from '../../Media/FooterLogo.webp'; 
import Linkedin from '../../Media/iconLinkedin.webp'; 
import Twitter  from '../../Media/iconTW.webp'; 
import Insta    from '../../Media/iconInsta.webp'; 
import Youtube  from '../../Media/iconYoutube.webp'; 
import "./Footer.css";

const Footer = () => {
    return (
        <footer>
            <img src =  {logo} alt = "SOVOS" />
            <div className = "footerContact">
                <a href = "https://g.page/SovosTurkey?share" target = "_blank" rel = "noopener noreferrer">
                    Altayçeşme Mh. Öz, Sokak. No. 19/10 45 Gold Plaza 34843 Maltepe İstanbul, Türkiye
                </a>
                <a href = "Tel:0216 445 93 79 ">
                    +90 216 445 93 79
                </a>
            </div>

            <div className = "footerSocials">
                <a href = "https://www.linkedin.com/company/sovos/"      ><img src = {Linkedin} alt = "Linkedin"/></a>
                <a href = "https://twitter.com/sovosturkey"              ><img src = {Twitter}  alt = "Twitter"/></a>
                <a href = "https://www.instagram.com/sovosturkiye/?hl=tr"><img src = {Insta}    alt = "Insta"/></a>
                <a href = "https://www.youtube.com/c/SovosCompliance"    ><img src = {Youtube}  alt = "Youtube"/></a>
            </div>
        </footer>
    )
}

export default Footer;



                


